"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _Card = _interopRequireDefault(require("../Card/Card"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _constants = require("../constants");
var _content = require("../../content");
var BlogPost = function BlogPost(_ref) {
  var post = _ref.post;
  if (post) {
    var blogPostDate = (0, _moment["default"])(post.date).format('Do MMMM YYYY');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tyw-blog-post flex flex-column height-100%"
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: post.link
    }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      template: "ImageCard",
      size: "xs",
      bgImage: {
        url: post.featured_image_src,
        alt: post.title.rendered
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-column justify-between height-100% margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-component"
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: post.link
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-md"
    }, post.title.rendered)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-sm d8-u-text-semi-bold d8-u-color-contrast-high"
    }, blogPostDate), /*#__PURE__*/_react["default"].createElement("p", null, (0, _content.textTruncate)(post.excerpt.rendered))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "d8-u-color-primary",
      link: post.link,
      text: "Read more",
      buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
      icon: "arrow-right",
      iconFlip: true
    }))));
  }
  return null;
};
BlogPost.propTypes = {
  post: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = BlogPost;